import React from 'react';
import { getRuntimeConfig } from '../../lib/runtimeConfig';
import { useFlags, withLDProvider } from 'launchdarkly-react-client-sdk';
import { basicLogger } from 'launchdarkly-js-client-sdk';
import MaintenanceComponent from '../Maintenance/MaintenanceComponent';

const publicRuntimeConfig = getRuntimeConfig();

type LaunchDarklyProps = React.FC<{
  children?: React.ReactNode;
}>;

const LaunchDarkly: LaunchDarklyProps = ({ children }) => {
  const { maintenance } = useFlags();

  return maintenance ? <MaintenanceComponent /> : <>{children}</>;
};

export default withLDProvider({
  clientSideID: publicRuntimeConfig.launchDarklyClientSideID,
  context: {
    kind: 'user',
    key: 'any-user',
  },
  options: {
    logger: basicLogger({ level: 'warn' }),
    // The SDK calls allFlags() on init; without this, that reports an
    // evaluation for every flag. useFlags() reads still report normally.
    sendEventsOnlyForVariation: true,
  },
})(LaunchDarkly) as LaunchDarklyProps;
